import { DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP } from '../contants';
/**
 * 방향 별 각 노드의 Edge 기준점 반환
 * Returns two corners (a and b) coordinates that are used as a reference points
 * Where "a" is always leftmost and topmost corner, and "b" is rightmost bottommost corner
 */
var getRefCornersFromEdge = function (direction, layout, isSibling) {
    if (isSibling === void 0) { isSibling = false; }
    var itemX = layout.left || 0;
    var itemY = layout.top || 0;
    var itemWidth = layout.width || 0;
    var itemHeight = layout.height || 0;
    var result = {
        a: {
            x: 0,
            y: 0,
        },
        b: {
            x: 0,
            y: 0,
        },
    };
    switch (direction) {
        case DIRECTION_UP: {
            var y = isSibling ? itemY + itemHeight : itemY;
            result.a = {
                x: itemX,
                y: y,
            };
            result.b = {
                x: itemX + itemWidth,
                y: y,
            };
            break;
        }
        case DIRECTION_DOWN: {
            var y = isSibling ? itemY : itemY + itemHeight;
            result.a = {
                x: itemX,
                y: y,
            };
            result.b = {
                x: itemX + itemWidth,
                y: y,
            };
            break;
        }
        case DIRECTION_LEFT: {
            var x = isSibling ? itemX + itemWidth : itemX;
            result.a = {
                x: x,
                y: itemY,
            };
            result.b = {
                x: x,
                y: itemY + itemHeight,
            };
            break;
        }
        case DIRECTION_RIGHT: {
            var x = isSibling ? itemX : itemX + itemWidth;
            result.a = {
                x: x,
                y: itemY,
            };
            result.b = {
                x: x,
                y: itemY + itemHeight,
            };
            break;
        }
        default:
            break;
    }
    return result;
};
export default getRefCornersFromEdge;
